/** @module csi/slicer/slicerSticky */
define([
	"dojo/_base/declare",
	"dojo/dom-class",
	"dojo/dom-style",
	"csi/_base/underscore",
	"csi/html"
], function(declare,domClass,domStyle,_,html) { 

	return declare(null,{
		/** @property {Object} _stickyContainer - contentainer */
		_stickyContainer: null,
		/** @property {Object[]} _elements */
		_elements: [],
		/** @property {String[]} _elementsIds */
		_elementsIds: [],
		/** @property {String[]} _elementsIdsNew */
		_elementsIdsNew: [],
		/** @property {Number} _oldDelta */
		_oldDelta: 0,
		/** @property {Number} _offset - sum of added elements offsetHeights */
		_offset: 0,
		/** @property {Number} _firstSticky - current first sticky row */
		_firstSticky: 0,
		/** @property {Number] _maxLevel - If tree have only leaves - maxLevel = 0, otherwise, maxLevel == number of nested branches (maxLevel == level of leaves) */
		_maxLevel: 0,
		/** @property {Object} _lastElem - data of last element, which had partial scrolling visibility */
		_lastElem: null,
		/** @property {Object} _grid - reference to slicer grid */
		_grid: null,
		/** @property {Object} _rows - array of rows to work with */
		_rows: null,
		
		/**
		 * Create sticky container
		 * @param {Object} node - parent node. For dgrid it should be grid scroll node (aka grid.bodyNode), so grid's horizontal scrolling will include sticky in scrolling.
		 * @param {Number} maxLevel - level of leaves
		 * @param {Object} grid - reference to grid
		 */
		constructor: function(node, maxLevel, grid){
			this._stickyContainer = html.create('div',{'class':'csi-sticky-container'}, node);
			this._maxLevel = maxLevel;
			this._grid = grid;
			this.resize();
		},
		
		/**
		 * Function code cloned from /dojo/newDgrid/Tree
		 * Call gridExpand on click and dblClick events
		 * @param {Object] event 
		 */
		treeOnClick: function(event) {
			var grid = this._grid;
			var row = grid.row(event);
			if ((!grid.collection.mayHaveChildren || grid.collection.mayHaveChildren(row.data)) &&
				(event.type !== 'keydown' || event.keyCode === 32) ) {
				grid.expand(row);
			}
		},
		
		/**
		 * Add new element to sticky container
		 * @param {Object} elem - dom original element to add
		 */
		add: function(elem){
			function onClick(ev){
				ev.target = elem;
				self.treeOnClick(ev);
				self._grid.scrollTo({y:elem.offsetTop - elem2.offsetTop});
			};

			var self = this;
			var elem2 = html.cloneElement(elem);
			this._offset += elem.offsetHeight;

			// Forward events from sticky to original elements 
			var jElem2 = $(elem2);
			jElem2.dblclick(onClick);
			jElem2.find('.dgrid-expando-icon').click(onClick);
			
			elem2.oHeight = elem.offsetHeight;
			this._elements.push(elem2);
			var id = elem.getAttribute('id');
			this._elementsIdsNew.push(id);
		},
	
		/**
		 * Clear data, prepare for new calculation. Private, use empty() instead; 
		 * @param {boolean} [bEmptyContainer=false] - if false, function will reset calculation data, 
		 *   preparing for next round; if true, it will also empty container element  
		 */
		_clear: function(bEmptyContainer){
			this._offset = 0;
			this._elements.length = 0;
			this._elementsIdsNew = [];
			if (bEmptyContainer) {
				$(this._stickyContainer).empty(); // I am using JQ empty because it also removes event handlers.
			}
		},
		
		/**
		 * Empty sticky container and reset data
		 */
		empty: function(){
			this._clear(true);
			this._elementsIds.length = 0;
		},
		
		/**
		 * Delete array of rows, should be called every time when set of source rows was changed
		 */
		deleteRows: function(){
			this.rows = null;
		},
		
		/**
		 * Return status of rows 
		 * @return {boolean} - return true, if rows are set 
		 */
		rowsDefined: function(){
			return !!this.rows;
		},

		/**
		 * Return true if sticky container is empty;
		 * @return {boolean}
		 */
		isEmpty: function() {
			return this._offset == 0;
		},
		
		/**
		 * Set array of rows
		 * @param {Object} rows - jQuery variable $(scrollNode).find('row_class'), array of rows to work with 
		 */
		setRows: function(rows){
			this._rows = rows;
		},
		
		/**
		 * Update container size and position to reflect grid resize changes
		 */
		resize: function(){
			// dgrid header's bounding rectangle: first parent is dgrid-scroller, second is dgrid-grid (container), first child is header
			var rect = this._stickyContainer.parentNode.parentNode.children[0].getBoundingClientRect(); 
			domStyle.set(this._stickyContainer, 'top', rect.bottom + html.PX);
			domStyle.set(this._stickyContainer, 'width', rect.width + html.PX);
		},
		/**
		 * Render sticky container and position horizontal scroll bar
		 * @param {Number} scrollLeft 
		 * @param {Number} delta - last row offset;
		 */
		render: function(scrollLeft, delta){
			if ( _.isEqual(this._elementsIdsNew,this._elementsIds)){ // Optimization?
				if (delta == this._oldDelta){ // scrolling through leaves, same sticky set, no fine scrolling
					this._clear();
					return;
				} else if (delta && this._lastElem){ // same sticky set but fine scrolling: only shifting bottom sticky row
					var lastElem = this._lastElem;
					var shift = delta-lastElem.height;
					domStyle.set(lastElem.element, {position: 'relative', 'z-index': '-1', top: shift+html.PX});
					domStyle.set(lastElem.e, {height: lastElem.offset + shift +html.PX});
					this._oldDelta = delta;
					this._elementsIds = this._elementsIdsNew;
					this._clear();
					return;
				}
			} 
			// Fully recreate sticky, sticky rows changed
			var e = html.create('div');
			_.each(this._elements, function(element, idx){
				e.appendChild(element);
				if (delta && (idx == this._elements.length - 1)){
					var shift = delta-element.oHeight;
					domStyle.set(element, {position: 'relative', 'z-index': '-1', top: shift+html.PX});
					domStyle.set(e, {height: this._offset + shift +html.PX});
					this._lastElem = {height:element.oHeight, element:element,e:e,offset:this._offset};
				} else {
					this._lastElem = null;
				}
			}, this);
			this._oldDelta = delta;
			this._elementsIds = this._elementsIdsNew;
			this._clear(true);
			this._stickyContainer.appendChild(e);
			if (scrollLeft) { // sticky container horizontal scroll positioning
				$(e).find('.dgrid-column-set-1 .dgrid-column-set').scrollLeft(scrollLeft);
			}
		},
		
		/**	
		 * Find rows that should be sticky, add to the container
		 * @param {Object} scrollNode
		 * @param {Object} rows - jQuery array of rows 
		 * @param {Number} scrollLeft - grid horizontal scroll position 
		 */
		scroll: function(nodeScrollTop, nodeScrollLeft){
			function shouldSticky(row, n, level, maxLevel, self){
				for (var j=n; j < rows.length; j++){
					var r = rows[j];
					var nextLvl = html.getDataAttribute(r,'level');
					if ( nextLvl > level){ // If next row is the same level or above this - don't sticky this row
						if (r.offsetTop + r.offsetHeight > scrollTop){
							delta = 0;
							var d = r.offsetTop + r.offsetHeight - scrollTop;
							var k = j;
							while ( (d < row.offsetHeight) && (k+1 < rows.length) ) {// is the "r" is not as toll as "row" we need to check next line to determine delta
								r = rows[++k];
								nextLvl = html.getDataAttribute(r,'level');
								if (nextLvl < maxLevel){ // Leaf == maxLevel, here checking if it is not a leaf.
									delta = d;
									return true;
								}
								d = r.offsetTop + r.offsetHeight - scrollTop;
							}
							return true;
						}
					} else {
						// Optimization: if we found the same (or above) level sub total, then skip the space between them in main loop
						if (j-1 > i) {
							i = j-1;
						}
						return false;
					}
				}
			}
			if (nodeScrollTop == 0){
				this.empty();
				return;
			}
			
			var rows = this._rows;
			if (nodeScrollTop < rows[this._firstSticky].offsetTop){
				this._firstSticky = 0;
			}
			var currLevel = -1; // Prevent adding same level sub totals to sticky more then once
			var delta = 0;
			for (var i = this._firstSticky; i < rows.length-1; i++){
				var row = rows[i];
				var scrollTop = nodeScrollTop + this._offset;
				if (row.offsetTop > scrollTop){
					break;
				}
				if (domClass.contains(row,'csi-slicer-row-subtotal')){
					var level = html.getDataAttribute(row,'level');
					if (level <= currLevel){
						break;
					}
					if ( shouldSticky(row, i+1, level, this._maxLevel, this)){
						if (this.isEmpty()){
							this._firstSticky = i;
						}
						this.add(row);
						currLevel = level; // we already added this level, don't add it again
					}
				}
			}
			if (currLevel < 0){ // Have we ever added something to sticky?
				this.empty(); 
			} else {
				this.render(nodeScrollLeft, delta);
			}
		}
	});
});
